<template>
    <div class="bg-light p-3 mt-3 sidebar-sub-container" id="insurance">
        <h3 class="sidebar-sub-container-headline">Versicherungs-Details</h3>
        <p class="sidebar-sub-container-body mb-2">
            Selbstbeteiligung: {{ participation }} {{ currency }}<br>
        </p>
        <ul class="li-checkmark">
            <li><i class="fal fa-check text-success"></i> Haftpflicht und Vollkasko inklusive
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Insurance",
        props: {
          currency: {
            type: String,
            default: "€"
          },
            vehicle: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            },
            defaultDamageParticipation:{
                type: Number,
                required: true
            }
        },
        data() {
            return {
                damageParticipation: {}
            };
        },
        methods: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },
        computed: {
            participation() {

                let damage_participation = this.subscription.damage_participation;
                if (typeof damage_participation === 'undefined' || damage_participation === null) {
                    return this.formatPrice(this.defaultDamageParticipation);
                } else {
                    return this.formatPrice(damage_participation.participation);
                }
            }
        }
    }
</script>


<style scoped>

</style>
